import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MessageCircle, MapPin } from 'lucide-react';
import { siteConfig } from '../data/mock';
import { EN_FOOTER_SERVICES, EN_FOOTER_AREAS, EN_AREA } from '../data/englishPages';
import LanguageSwitcher from './LanguageSwitcher';

const EnglishFooter = () => {
  const { contact } = siteConfig;
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300" data-testid="en-footer">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-white font-bold text-lg mb-3">Le Rosebif</h3>
            <p className="text-sm leading-relaxed">
              A British-run, English-speaking garden maintenance service based in Coëx, Vendée — for holiday homes,
              second homes, campsite/mobile-home owners and local residents.
            </p>
            <div className="mt-4 space-y-2 text-sm">
              <a href={`tel:${contact.phone}`} className="flex items-center gap-2 hover:text-lime-400 transition-colors"><Phone size={15} /> {contact.phone}</a>
              <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-lime-400 transition-colors"><MessageCircle size={15} /> WhatsApp</a>
              <a href={`mailto:${contact.email}`} className="flex items-center gap-2 hover:text-lime-400 transition-colors break-all"><Mail size={15} /> {contact.email}</a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-3">Services</h3>
            <ul className="space-y-2 text-sm">
              {EN_FOOTER_SERVICES.map((l) => (
                <li key={l.to}><Link to={l.to} className="hover:text-lime-400 transition-colors">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Areas */}
          <div>
            <h3 className="text-white font-semibold mb-3">Areas near Coëx</h3>
            <ul className="space-y-2 text-sm">
              {EN_FOOTER_AREAS.map((l) => (
                <li key={l.to}><Link to={l.to} className="hover:text-lime-400 transition-colors">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Contact / area */}
          <div>
            <h3 className="text-white font-semibold mb-3">Get in touch</h3>
            <Link to="/en/contact" className="inline-block bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-lg px-4 py-2 text-sm transition-colors" data-testid="en-footer-contact-btn">
              Get a free quote
            </Link>
            <p className="text-sm mt-4 flex items-start gap-2"><MapPin size={15} className="mt-0.5 flex-shrink-0" /> {EN_AREA.slice(0, 6).join(' · ')} and nearby villages.</p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm">
          <p>© {year} Le Rosebif — Service à la Personne SAP813136249, Coëx, Vendée.</p>
          <LanguageSwitcher className="text-gray-300" />
        </div>
      </div>
    </footer>
  );
};

export default EnglishFooter;
